import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import randomColor from 'randomcolor';
import * as L from 'leaflet';
import 'leaflet-textpath';
import  'leaflet.markercluster';
import  'leaflet-easybutton';
import simplify from 'simplify-js';


// delete (<any>L.Icon.Default.prototype)._getIconUrl;
// L.Icon.Default.mergeOptions({
// 	iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
// 	iconUrl: require('leaflet/dist/images/marker-icon.png'),
// 	shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
// });

function calculateDistance(point1:any,point2:any, unit) {

  let [lat1, lon1] = [point1.lat,point1.lng];
  let [lat2, lon2] = [point2.lat,point2.lng];
  var radlat1 = Math.PI * lat1/180
  var radlat2 = Math.PI * lat2/180
  var radlon1 = Math.PI * lon1/180
  var radlon2 = Math.PI * lon2/180
  var theta = lon1-lon2
  var radtheta = Math.PI * theta/180
  var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  dist = Math.acos(dist)
  dist = dist * 180/Math.PI
  dist = dist * 60 * 1.1515
  if (unit=="K") { dist = dist * 1.609344 }
  if (unit=="N") { dist = dist * 0.8684 }
  return dist
}

const frMap:any = {
  new: 'nouvelle',
  inventory: 'inventaire',
  transported: 'transportée',
  modified: 'modifiée'
}
const logPileIcon = function(status:string){
  let image:string;
  switch(status){
    case 'transported':
      image = 'log-pile-transported.png';
    break;
    case 'modified':
      image = 'log-pile-modified.png';
    break;
    default:
    image = 'log-pile.png';
    break;
  }
  return L.icon({
    iconUrl: `assets/map-markers/${image}`,
    shadowUrl: 'assets/map-markers/log-pile-shadow.png',
    iconSize: [28, 16],
    shadowSize: [0, 0],
    iconAnchor: [14, 16],
    shadowAnchor: [0, 0],
    popupAnchor: [-3, -40]
  });
}

@Component({
  selector: 'app-leaflet-map',
  templateUrl: './leaflet-map.component.html',
  styleUrls: ['./leaflet-map.component.scss'],
})
export class LeafletMapComponent implements OnInit {
  @Input() attachments:File[];

  @Input() set piles( piles:any[]){
    const pilesWithPosition = [];
    if(!piles) return;
    piles.forEach( ( p )=>{

      if(p.position && p.position.latitude && p.position.longitude){
        const {latitude,longitude} = p.position;

        const latLng = L.latLng(latitude,longitude);
        const mData = {
          options: {
            title: p.id,
            tooltip: p.id,
            icon: logPileIcon(p.status)
          },
          popup: `${p.id} ${p.essence?.code} (${frMap[p.status]})`,
          latLng: latLng,
          pile: p
        }
        this.hasBounds = true;
        this.bounds.extend(latLng)
        pilesWithPosition.push(mData);
      }
    })

    this.markerData = pilesWithPosition;
    this.createMap();
    this.createCenterControl();
    this.appendLayers();
    this.appendMarkers();


  }

  @ViewChild('mapContainer') mapContainer: ElementRef;
  private hasBounds:boolean = false;
  private markerData:any[]=[];
  private map: L.Map;
  private bounds: L.LatLngBounds = new L.LatLngBounds([]);
  private baseLayer: L.TileLayer;
  private pileMarkers: L.Marker<any>[];
  private markerClusterGroup:L.MarkerClusterGroup;
  public roadLegend:any[] = [];
  public roadMap:any = {};
  public visibilities:any = {
    inventory: true,
    modified: true,
    transported: true
  }
  public currentPile:any;
  constructor() {

  }

  ngOnInit() {

  }
  createCenterControl(){

    L.easyButton('<ion-icon style="font-size:18px;margin:0;padding:0;margin-top:3px;" class="compass-button" name="globe-outline"></ion-icon>', (btn, map)=>{
      this.map.fitBounds(this.bounds);
    }).addTo( this.map );


  }
  appendMarkers(){
    if(!this.markerClusterGroup){
      this.markerClusterGroup = new L.MarkerClusterGroup({
        showCoverageOnHover: false,
        maxClusterRadius: 5,
        animateAddingMarkers: true,
        zoomToBoundsOnClick: true
      });
      this.map.addLayer(this.markerClusterGroup)
    }
    this.pileMarkers = this.markerData.map( (mark:any)=>{
      mark.options.pile = mark.pile;
      const marker = L.marker(mark.latLng,mark.options);
      marker.on('mousemove', (e)=>{
        this.currentPile = mark.pile;
      })
      this.markerClusterGroup.addLayer(marker);
      return marker;
    })

  }

  createRoads(){
    const roadMap= {};
    this.markerData.forEach( ( mark:any)=>{
      let position = mark.latLng;
      let road = mark.pile.road;
      if(!roadMap[road]){
        roadMap[road]=[];
      }
      roadMap[road].push(position);
    })
    Object.keys(roadMap).forEach( ( road:string)=>{
      let nodes:any[] = roadMap[road];
      let bounds = new L.LatLngBounds([]);
      nodes.forEach( (n:any)=>{
        bounds.extend(n);
      })

      let smallX=Infinity;
      let smallY=Infinity;
      nodes.forEach( (n:any)=>{
        if(n.lat < smallX && n.lng < smallY){
          smallX = n.lat;
          smallY = n.lng;
        }

      });
      let first = new L.LatLng(smallX,smallY)
      let sorted = [...nodes.sort( (a,b)=>{

        let adist = calculateDistance(first,a,"K")
        let bdist = calculateDistance(first,b,"K")
        return adist- bdist;
      })];



      nodes = sorted.reduce( ( left:any[], node:any,index:number)=>{
        if(!sorted[index+1]) return left;
        let dist = calculateDistance(node,sorted[index+1],"K");
        if(dist > 0.05){
            left.push(node);
          // }
        }else{
            left.push(sorted[index+1])
        }
        return left;
      },[]);
      nodes.unshift(sorted[0]);
      nodes.push(sorted[sorted.length-1]);
      if(nodes.length < 2){

      }



      const colorLine = randomColor({hue:'purple',seed:road,luminosity:'bright'});
      const colorDark = randomColor({hue:'purple',seed:road,luminosity:'dark'});
      const line = L.polyline(nodes, {smoothFactor:1,color: colorLine });
      line.setText(road, {center: true,attributes: {fill:colorDark,'font-weight':'bold','font-size':'14px'}});
      line.addTo(this.map)
      this.roadLegend.push( {
        name: road,
        color: colorLine
      })
      this.roadMap[road]=line;
    })
  }
  appendLayers(){
    this.baseLayer = L.tileLayer('https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', {
        minZoom: 0,
        maxZoom: 22,
        maxNativeZoom: 14,
        attribution: 'Kartendaten: &copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a>-Mitwirkende, SRTM | Kartendarstellung: © <a href="http://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
      }).addTo(this.map);
    this.createRoads();
  }
  zoomToRoad(name:string){
    let line = this.roadMap[name];
    this.map.fitBounds(line.getBounds());
  }
  togglePilesByStatus(status:string){
    if(this.visibilities[status]){
      this.visibilities[status]=false;
      // turn off
      this.pileMarkers.forEach( (m:any)=>{
        if(m.options.pile.status == status){

          this.markerClusterGroup.removeLayer(m)
        }
      })
    }else{
      this.visibilities[status]=true;
      // turn on
      this.pileMarkers.forEach( (m:any)=>{
          if(m.options.pile.status == status){
            this.markerClusterGroup.addLayer(m)
          }
      })
    }
  }
  createMap(){
    let center:L.LatLng = L.latLng([48.563484595514154, -78.17019985015912]);
    if(this.hasBounds){
      center = this.bounds.getCenter();
    }

    this.map = L.map(this.mapContainer.nativeElement).setView(center, 13);
    if(this.bounds.isValid()){
      this.map.fitBounds( this.bounds );
    }


    this.map.on('zoomend', ()=>{
      console.log(this.map.getZoom());
    })
  }




  // L.marker([51.5, -0.09]).addTo(map)
  //   .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
  //   .openPopup();
  // }

}
